// extracted by mini-css-extract-plugin
export default {"wrapper":"GridItem_wrapper__KNSR-","iconBox":"GridItem_iconBox__Mq+kZ","description":"GridItem_description__KW-36"};